import React, { useCallback } from 'react';
import { NavLink, NavLinkProps, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import classnames from 'classnames';

type PropsType = NavLinkProps &
    React.RefAttributes<HTMLAnchorElement> & {
        isActive?: boolean;
    };

export const UiNavLink = observer(({ onClick, className, isActive = false, ...props }: PropsType) => {
    const location = useLocation();
    const handleClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            if (!e.currentTarget.contains(e.target as Node)) {
                //check its portal(modal/portal inside link)
                e.stopPropagation();
                e.preventDefault();
                return;
            }
            window.scrollTo(0, 0);
            onClick && onClick(e);
        },
        [onClick]
    );

    const _isActive = location.pathname === props.to || isActive;
    const _className = typeof className === 'function' ? className({ isActive: _isActive, isPending: false, isTransitioning: false }) : className
    const classNames = classnames('ui-new-nav-link', _className, {
        'ui-new-nav-link--active': _isActive,
        [`${_className}--active`]: _isActive,
    });

    return <NavLink {...props} onClick={handleClick} className={classNames} />;
});
